import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditCountry from "../../Components/Admin/AdminEditCountry";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditCountryPage = () => {
  return (

    <AdminEditCountry />

  );
};

export default AdminEditCountryPage;